module.exports = __webpack_public_path__ + "img/contact-page-cover.6bcf88d3.png";